import type { Routes } from 'react-resource-router';
import { homeRoute } from '@atlassian/twg-microsite-experience';

export const routes: Routes = [homeRoute] as const;
